import {
  GET_SHOPPING_AREAS,
  GET_SHOPPING_AREAS_SUCCESS,
  API_ERROR,
  GET_SHOPPING_AREAS_V2,
  GET_SHOPPING_AREAS_V2_SUCCESS,
  GET_SHOPPING_AREAS_V2_ERROR,
} from "./actionTypes"

export const getShoppingAreas = () => ({
  type: GET_SHOPPING_AREAS,
  payload: {},
})

export const getShoppingAreasSuccess = shoppingAreas => {
  return {
    type: GET_SHOPPING_AREAS_SUCCESS,
    payload: { shoppingAreas },
  }
}

export const apiError = error => {
  return {
    type: API_ERROR,
    payload: error,
  }
}

export const getShoppingAreasV2 = () => ({
  type: GET_SHOPPING_AREAS_V2,
  payload: {},
})

export const getShoppingAreasV2Success = shoppingAreas => {
  return {
    type: GET_SHOPPING_AREAS_V2_SUCCESS,
    payload: { shoppingAreas },
  }
}

export const getShoppingAreasV2Error = error => {
  return {
    type: GET_SHOPPING_AREAS_V2_ERROR,
    payload: error,
  }
}